import React, { useEffect, useState } from "react";
import SingleHistory from "./SingleHistory";
import { Chrono } from "react-chrono";
import ApiService from "../../../../ApiService";
import { set } from "lodash";

function formatDate(inputDate) {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const date = new Date(inputDate);
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date
    .getFullYear()
    .toString()
    .substr(-2);

  return `${day} ${month} '${year}`;
}

export default function PatientHistory({ patientId, patientEmail }) {
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const fetchHistory = async () => {
      try {
        const res = await ApiService.getEventsForPatient(patientEmail);
        setHistory(res.data.sort((a, b) => (a.created < b.created ? 1 : -1)));
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        // setIsLoading(false);
      }
    };
    fetchHistory();
  }, []);

  return (
    <div className="dashboardContent">
      <div className="tabsContent historyContent px-4">
        {!isLoading &&
          history?.map((item, index) => {
            return (
              <div key={index}>
                <div style={{ width: "150px" }}>
                  <h5 className="text-center">{formatDate(item?.created)}</h5>
                </div>
                <Chrono hideControls disableNavOnKey theme={{ primary: "#a8a8a8", secondary: "green" }} mode="VERTICAL">
                  <SingleHistory leftName={item?.entityType} leftValue={item?.entityId} rightName={item?.eventType} rightValue={item?.actorType} />
                </Chrono>
              </div>
            );
          })}
        {isLoading ? <p className="loading"></p> : <h1 className="noRecordFound">No History Found</h1>}
        {/* <div>
          <div style={{ width: "150px" }}>
            <h5 className="text-center">Today</h5>
          </div>
          <Chrono hideControls disableNavOnKey theme={{ primary: "#a8a8a8", secondary: "green" }} mode="VERTICAL">
            <SingleHistory />
          </Chrono>
        </div> */}

        {/* <div>
          <div style={{ width: "150px" }}>
            <h5 className="text-center">January 2, 2023</h5>
          </div>
          <Chrono hideControls disableNavOnKey theme={{ primary: "#a8a8a8", secondary: "green" }} mode="VERTICAL">
            <SingleHistory />
            <SingleHistory />
          </Chrono>
        </div> */}
      </div>
    </div>
  );
}
